import { Checkbox, Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { PropTypes } from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { tr } from '@/common/utils/tr';
import {
    buildSourceLangOptions,
    buildTargetLangOptions,
    isTargetOptionDisabled,
    isMaxTargetLangsReached
} from './handler/FileTranslationDialogHandler';

/**
 * 翻訳元言語 (single) + 翻訳先言語 (multi) selects.
 *
 * Both are searchable: with 105 languages a plain select is unusable.
 */
function TranslationLanguageSelect({ sourceLang, targetLangs, langStatusMap, onChangeSourceLang, onChangeTargetLangs }) {
    const autoDetectLabel = trI18n('LABEL-TRANSLATION-AUTO-DETECT');
    const sourceOptions = buildSourceLangOptions(autoDetectLabel);
    const targetOptions = buildTargetLangOptions(sourceLang, langStatusMap);
    const isMaxReached = isMaxTargetLangsReached(targetLangs);

    const selectedSourceOption = sourceOptions.find(option => option.code === sourceLang) || sourceOptions[0];
    const selectedTargetOptions = targetLangs
        .map(code => targetOptions.find(option => option.code === code) || { code, nameJp: code });

    return (
        <>
            <div className="file-translation-field">
                <label className="file-translation-label">{trI18n('LABEL-TRANSLATION-SOURCE-LANG')}</label>
                <Autocomplete
                    className="file-translation-select"
                    options={sourceOptions}
                    value={selectedSourceOption}
                    getOptionLabel={option => option.nameJp}
                    getOptionSelected={(option, value) => option.code === value.code}
                    disableClearable
                    onChange={(event, option) => onChangeSourceLang(option?.code)}
                    popupIcon={<ExpandMoreIcon fontSize="small"  />}
                    renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                />
            </div>

            <div className="file-translation-field">
                <label className="file-translation-label">{trI18n('LABEL-TRANSLATION-TARGET-LANG')}</label>
                <div className="file-translation-select-wrap">
                    <Autocomplete
                        className="file-translation-select file-translation-select-multi"
                        multiple
                        disableCloseOnSelect
                        options={targetOptions.filter(option => !targetLangs.includes(option.code))}
                        value={selectedTargetOptions}
                        getOptionLabel={option => option.nameJp}
                        getOptionSelected={(option, value) => option.code === value.code}
                        getOptionDisabled={option => isTargetOptionDisabled(option, targetLangs)}
                        onChange={(event, options) => onChangeTargetLangs(options.map(option => option.code))}
                        renderOption={(option, { selected }) => (
                            <>
                                {option.nameJp}
                            </>
                        )}
                        popupIcon={<ExpandMoreIcon fontSize="small" />}
                        renderTags={(options, getTagProps) =>
                            options.map((option, index) => {
                                const { key, ...tagProps } = getTagProps({ index });
                                return <Chip key={option.code} label={option.nameJp} {...tagProps} />;
                            })
                        }
                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                    />
                    {isMaxReached && (
                        <div className="file-translation-max-message">{trI18n('MSG-TRANSLATION-MAX-TARGET-LANGS')}</div>
                    )}
                </div>
            </div>
        </>
    );
}

TranslationLanguageSelect.propTypes = {
    sourceLang: PropTypes.string.isRequired,
    targetLangs: PropTypes.array.isRequired,
    langStatusMap: PropTypes.object,
    onChangeSourceLang: PropTypes.func.isRequired,
    onChangeTargetLangs: PropTypes.func.isRequired
};

export default TranslationLanguageSelect;
